import React, {Component} from 'react'
import {FormattedMessage} from 'react-intl'
import LoadingSpinner from '../../common/spinner/loading.component.jsx'
import {AppContext} from '@lightspeed-invoicing/core-client/frontend'
import EventBus from '../../common/EventBus.js'
import TemplateHeader from "../../common/template/header.component.jsx"
import WorkOrderReceiptItems from "./section/items.component.jsx";

class WorkOrderReceipt extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            receipt: null,
            options: [],
            showApprovedMessage: false,
        }
    }

    componentDidMount() {
        AppContext.getApiClient().get('/work-order-receipts/' + this.props.match.params.hash).then(res => {
            EventBus.dispatch(EventBus.TopicLocaleChange, {
                locale: res.attributes.variables.global.language,
            })
            this.setState({
                receipt: res.attributes.variables
            })
        })
    }

    render() {
        if (!this.state.receipt) {
            return <LoadingSpinner marginTop="20px" />
        }

        return <div className="row ui-has-modules justify-content-md-center final-proposal">
            <TemplateHeader value={this.state.receipt} />
            <WorkOrderReceiptItems value={this.state.receipt} />
        </div>
    }

}

export default WorkOrderReceipt





// WEBPACK FOOTER //
// ./src/workorder/receipt/receipt.component.jsx